<template>
  <LayoutDefault>
    <section
            class="container"
            id="about_divas"
    >
      <div class="content">
        <div class="logo-container">
          <img src="/img/logo-cursive.png">
        </div>
        <div class="text" v-html="$cms.string('about_us.text', $t('loading'))">
        </div>
        <div class="footer">
          <p>
            DIVASTV - DIVASPLAY - DIVASLECLUB - HAPPYHAPPY
          </p>
        </div>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
    import LayoutDefault from "../layouts/LayoutDefault";
    export default {
      components: {LayoutDefault}
    }
</script>

<style scoped lang="scss">
  @import './../styles/variables';

  #about_divas{
    background-color: #000000;
    color: #ffffff;
    min-height: 650px;
    padding: 60px;
    display:flex;
    justify-content: flex-end;

    background-image: url('/img/about.png');
    background-size: contain;
    background-position: left bottom;
    background-repeat: no-repeat;

    @media(max-width: 350px) {
      padding: 15px;
    }

    @media(max-width: 960px){
      //background-position: left bottom;
      border-bottom: 2px solid var(--pallete_main_color);
    }

    .content{
      align-self: end;
      flex-basis: 50%;
      text-align: right;

      @media(max-width: 960px){
        flex-basis: 100%;
        margin-bottom: 70vw;

        text-align: center;
      }

      .logo-container{
        text-align: right;
        margin-bottom: 40px;

        img{
          width: 275px;

          @media(max-width: 350px) {
            width: 100%;
          }
        }
      }

      .text{

      }

      .footer p{
        margin-top: 3em;
        text-transform: uppercase;
        font-weight: bolder;
      }
    }
  }
</style>
